import { parseCookieHeader } from "@supabase/ssr";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ko", label: "한국어" },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]["code"];

export const DEFAULT_LANGUAGE: LanguageCode = "en";

export const LANG_COOKIE_NAME = "lang";

const isSupportedLanguage = (value: string): value is LanguageCode =>
  LANGUAGES.some((l) => l.code === value);

export function detectLocaleFromRequest(request: Request): LanguageCode {
  const cookies = parseCookieHeader(request.headers.get("Cookie") ?? "");
  const langCookie = cookies.find((c) => c.name === LANG_COOKIE_NAME)?.value;
  if (langCookie && isSupportedLanguage(langCookie)) return langCookie;

  const acceptLanguage = request.headers.get("Accept-Language") ?? "";
  for (const part of acceptLanguage.split(",")) {
    const tag = part.split(";")[0]?.trim().toLowerCase() ?? "";
    const primary = tag.split("-")[0];
    if (primary && isSupportedLanguage(primary)) return primary;
  }

  return DEFAULT_LANGUAGE;
}
